import React from "react"
import "./Footer.css"


const Footer = () => {
  return (
    
      
        <div className="ft">
          <span>
          Copyright © 2022 AIEC, Sur, Oman - All Rights Reserved.
          <a href="https://wa.me/96871198835/?text=Dear ROYYZ team, I would like to make a website for our company. Please contact me.">
          
        <button className="buttonfooter">ROYYZ</button>
        </a>
          </span>
         
        </div>
        
        
     
    
  )
}

export default Footer